module.exports = __webpack_public_path__ + "static/img/c4.43f8202.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c4.png
// module id = 279
// module chunks = 0 1 2 3 4 5 6 7 8 9